import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Subscribable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TradeskillsService {

  public static HTTP_SERVER = 'https://cuijpers.dynu.net';
  public static API_ENDPOINT = TradeskillsService.HTTP_SERVER + '/rest/';

  constructor(protected http: HttpClient) {
  }

  query(version: string): Subscribable<{}> {
    return this.http.get(TradeskillsService.API_ENDPOINT + 'tradeskills?version=' + version).pipe(map(this.extractData));
  }

  upload(uploadData: {}): Subscribable<{}> {
    return this.http.post(TradeskillsService.API_ENDPOINT + 'tradeskills', uploadData).pipe(map(this.extractData));
  }

  exportCsv(version: string): void {
    window.location.href = TradeskillsService.API_ENDPOINT + 'tradeskills/export?version=' + version;
  }

  protected extractData(res: Response): {} {
    return res || {};
  }
}
